import { ADMIN_OR_ABOVE } from "@excel-center/shared";

export const ADMIN_OR_ABOVE_ROLES = ADMIN_OR_ABOVE;

export const REPORT_IDS = ["students", "credentials", "jobs", "staff"] as const;

export type ReportId = (typeof REPORT_IDS)[number];
